import { SidebarMenuItem } from "@/src/sb/business-layer/types"

const MobileMenuItemsMock = (): Array<SidebarMenuItem> => {
  return [
    // SideBar Top Menu
    {
      id: 100001,
      icon:
        '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M14 1.75C7.23451 1.75 1.75 7.23451 1.75 14C1.75 20.7655 7.23451 26.25 14 26.25C20.7655 26.25 26.25 20.7655 26.25 14C26.2423 7.23771 20.7623 1.75772 14 1.75ZM3.5 14C3.50184 11.0188 4.77501 8.17999 7 6.19588V7.875C7 8.8415 7.7835 9.625 8.75 9.625H11.7092C12.3725 9.62531 12.979 9.25059 13.2755 8.65725L13.6649 7.875H15.75V11.375H11.5806C11.3094 11.3749 11.042 11.4378 10.7993 11.5588L7.96688 12.9763C7.37472 13.2726 7.00052 13.8777 7 14.5399V17.7818C6.99995 18.4973 7.43553 19.1408 8.09987 19.4066L11.4677 20.7541L12.061 24.3119C7.10206 23.3751 3.5085 19.0466 3.5 14ZM13.8652 24.493L13.0322 19.495L8.75 17.7826V14.5408L11.5815 13.125H17.5V6.125H12.5842L11.7092 7.875H8.75V4.92013C11.4472 3.35005 14.7045 3.06595 17.6327 4.14535C20.561 5.22476 22.8546 7.55498 23.8875 10.5H19.25V14L20.0567 17.3364L18.375 19.8608V23.5331C17.004 24.1689 15.5112 24.4988 14 24.5C13.9545 24.5 13.9107 24.4939 13.8652 24.493ZM20.125 22.5111V20.3901L21.5127 18.3076C21.7863 17.8972 21.8743 17.3906 21.7551 16.912L21 13.8924V12.25H24.3425C25.0408 16.1983 23.398 20.1951 20.125 22.5111Z" fill="currentColor"/>' +
        "</svg>",
      destination: "/",
      label: "Countries",
      parent_id: null,
      category_name: null
    },
    {
      id: 100002,
      icon:
        '<svg width="28" height="28" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M3.5025 21.2363L8.295 12.2363L13.77 17.1038C14.1174 17.4125 14.5883 17.5427 15.045 17.4563C15.5059 17.37 15.9 17.0731 16.11 16.6538L20.25 8.41133L18.885 7.73633L14.7675 15.9863L9.2925 11.1188C8.9539 10.8039 8.48901 10.6628 8.0325 10.7363C7.58181 10.8111 7.18976 11.0872 6.9675 11.4863L3 18.9863V1.73633H1.5V21.2363C1.5 22.0648 2.17157 22.7363 3 22.7363H22.5V21.2363H3.5025Z" fill="currentColor"/>\n' +
        "</svg>",
      destination: "/",
      label: "Data",
      parent_id: null,
      category_name: null
    },
    {
      id: 100003,
      icon:
        '<svg width="28" height="28" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 15.8334H8.54167V17.2917H1.25V15.8334ZM1.25 11.4584H8.54167V12.9167H1.25V11.4584ZM17.2917 8.54142H2.70833C1.90292 8.54142 1.25 7.8885 1.25 7.08309V2.70809C1.25 1.90267 1.90292 1.24976 2.70833 1.24976H17.2917C18.0971 1.24976 18.75 1.90267 18.75 2.70809V7.08309C18.75 7.8885 18.0971 8.54142 17.2917 8.54142ZM2.70776 2.70837V7.08337H17.2911V2.70837H2.70776ZM17.2911 18.75H12.9161C12.1107 18.75 11.4578 18.0971 11.4578 17.2917V12.9167C11.4578 12.1113 12.1107 11.4584 12.9161 11.4584H17.2911C18.0965 11.4584 18.7494 12.1113 18.7494 12.9167V17.2917C18.7494 18.0971 18.0965 18.75 17.2911 18.75ZM12.9172 12.9161V17.2911H17.2922V12.9161H12.9172Z" fill="currentColor"/>\n' +
        "</svg>",
      destination: "/",
      label: "Reports",
      parent_id: null,
      category_name: null
    }
  ]
}

export default MobileMenuItemsMock
